export const GET_VIP = "GET_VIP";
export const VALIDATE_VIP_WEEKLY_BONUS = "VALIDATE_VIP_WEEKLY_BONUS";
export const CLAIM_VIP_WEEKLY_BONUS = "CLAIM_VIP_WEEKLY_BONUS";

export const VALIDATE_VIP_BIRTHDAY_BONUS = "VALIDATE_VIP_BIRTHDAY_BONUS";
export const CLAIM_VIP_BIRTHDAY_BONUS = "CLAIM_VIP_BIRTHDAY_BONUS";

export const GET_VIP_DEPOSIT_TURNOVER = "GET_VIP_DEPOSIT_TURNOVER";